<template>
  <Can action="view" subject="invoice">
    <div data-component-group="invoice-dialog" data-component="edit">
      <dialog-edit
        icon="event"
        :to="`/invoices/${activeInvoice?.id}`"
        :title="activeInvoice.invoice_number"
        content-class="edit-invoice-dialog"
        is-fullscreen
        :is-on="true"
        :on-close="onCancel"
      >
        <template v-slot:content>
          <forms-invoice-edit
            :invoice="activeInvoice"
            :is-loading="isEditingInvoice"
            :on-cancel="onCancel"
            :on-submit="$ability.can('update', 'invoice') ? updateInvoice : undefined"
          />
        </template>
      </dialog-edit>
    </div>
  </Can>
</template>

<script>
  export default {
    data() {
      return {
        isEditingInvoice: false,
      };
    },
    created() {
      if (!this.activeInvoice?.id) {
        this.$store.dispatch('invoices/getItem', { id: this.$route.params.id });
      }
    },
    computed: {
      activeInvoice() {
        return this.$store.getters['invoices/activeItem'];
      },
    },
    methods: {
      onCancel() {
        this.$router.push({ name: 'invoices' });
      },
      updateInvoice({ status, paymentDate }) {
        const { id } = this.activeInvoice;
        const [day, month, year] = paymentDate.split('-');
        const formattedPaymentData = `${year}-${month}-${day}`;

        const query = {
          id,
          status,
          payment_date: formattedPaymentData,
        };

        this.isEditingInvoice = true;

        return this.$store
          .dispatch('invoices/update', query)
          .then((res) => {
            this.$router.push({ name: 'invoices', query: { status: 'success' } });
            return res;
          })
          .catch((err) => err)
          .finally(() => {
            this.isEditingInvoice = false;
          });
      },
    },
  };
</script>
